module.exports = __webpack_public_path__ + "assets/img/re11.3e2dcf73.png";